import jquery from 'jquery';
import EFOcats_event_core from '../../../core/v1/event/efocats_event_core.js';

/**
 * 回答した時のイベント
 */
export default class EFOcats_event_retro_input extends EFOcats_event_core {
  /**
   * コンストラクタ
   * @param validations エラーチェック処理配列
   */

  /**
   * イベントための事前の仕込み
   */
  init() {
    // 特に処理なし
  }

  /**
   * イベント本体をセット
   */
  event() {
    this.autokana();

    this.$('body').on('change.answer', 'input,select,textarea', event => {
      const element = event.currentTarget;
      this.answer_ev(jquery(element));
    });
  }

  /**
   * 回答イベント
   * @param obj
   */
  answer_ev(obj) {
    if (!obj.parents('section').hasClass('action')) {
      return;
    }

    if (obj.attr('type') === 'tel') {
      this.rep_yubin(obj);
    }

    const status_data = {status: ''};

    // エラーチェック
    efocats.validations.check_error(obj);

    if (obj.attr('type') === 'file') {
      this.file_disp_change(obj, status_data);
    }

    efocats.submit.status_individual(obj);
  }

  /**
   * カナ自動入力
   */
  autokana() {
    if (typeof window.jQuery === 'undefined') {
      window.jQuery = require('jquery');
    }

    const $ = window.jQuery;

    require('jquery.autokana');

    // autokanaを呼び出し
    this.$("[data-input^='input']").each((index, elem) => {
      const input_val = $(elem).attr('data-input').replace('input', 'output');
      $.fn.autoKana($(elem), this.$(`input[data-input='${input_val}']`), {
        katakana: true,
      });
    });

    this.$("[data-input^='input']")
      .parents('.container')
      .find('.next-btn')
      .on('click', e => {
        const input_target = this.$(e.target).parents('section').find("[data-input^='input']");
        const output_target = this.$(e.target).parents('section').next('section').find("[data-input^='output']");

        input_target.each((index, elem) => {
          const input_val = $(elem).attr('data-input').replace('input', 'output');
          const value = this.$(`input[data-input='${input_val}']`).val();

          if (value) {
            input_target.parents('.check-flag').addClass('ok-flag').addClass('icon-flag');
          } else {
            input_target.parents('.check-flag').removeClass('ok-flag').removeClass('icon-flag');
          }
        });

        if (input_target.parents('.container').find('.ok-flag').length === output_target.parents('.container').find('.ok-flag').length) {
          output_target.parents('.qa').addClass('go-flag');
        } else {
          output_target.parents('.qa').removeClass('go-flag');
        }
      });

    // this.$("[data-input^='output']")
    //   .parents('.container')
    //   .find('.next-btn')
    //   .on('click', e => {
    //     if (this.$(e.target).parents('section').find("[data-input^='output']").val() === '') {
    //       this.$(e.target).parents('section').find("[data-input^='output']").parents('.check-flag').removeClass('icon-flag');
    //     }
    //   });
  }
}
